export default __webpack_public_path__ + "static/media/garden2.36fac2d1.webp";